/**
 * Wrap setTimeout so it can be used with await.
 */
export const delay = (ms: number): Promise<unknown> => new Promise((resolve) => setTimeout(resolve, ms));
